module.exports = __webpack_public_path__ + "img/125.7dc1d7d1.jpg";